/**
 * Enter god mode on a workspace ("View as workspace") and land on `path` in
 * the product as that workspace. Super-admin only; the server decides.
 *
 * When the server wants a fresh MFA step-up, the target workspace and path
 * ride through the OAuth round trip so the callback resumes entering god
 * mode and lands on the same page, not back in admin. Resolves with the
 * server's error when entering failed; navigates away otherwise.
 */
export async function enterGodMode(
  workspaceId: string,
  path: string,
): Promise<{ ok: true } | { ok: false; error: string }> {
  const res = await fetch("/api/auth/god-mode/enter", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ workspaceId }),
  });
  if (!res.ok) {
    const body = (await res.json().catch(() => ({ error: "Unknown error" }))) as { error?: string };
    if (res.status === 401 && body.error === "mfa_required") {
      window.location.href =
        `/api/auth/google/step-up?godModeWorkspaceId=${encodeURIComponent(workspaceId)}` +
        `&returnTo=${encodeURIComponent(path)}`;
      return { ok: true };
    }
    return { ok: false, error: body.error ?? "Unknown error" };
  }
  window.location.href = path;
  return { ok: true };
}
